import React, { ReactNode, useState, useEffect } from 'react';
import {
    Box, Typography, useTheme, IconButton, Icon, useMediaQuery, Theme,    
    Button,
    Link,
    Badge
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useAppThemeContext, useDrawerContext } from "../contexts";
import { DialogFaleConoscoEvent } from '../../pages/contato/FaleConosco';
import { DialogNotificacoes } from '../components/modal/DialogNotificacoes';
import { IListaDadosNotificacoes, NotificacoesService } from '../services/api/notificacoes/NotificacoesService';
import { UtilidadeService } from '../services/api/utilidades/UtilidadesService';
import { DialogChatEvent } from '../../pages/chat/Chat';

interface ILayoutBaseDePagina {
    children?: ReactNode;
    titulo: string;
    barraDeFerramentas?: ReactNode;
    showLogoImg?: string;

};
export const LayoutBaseDePagina: React.FC<ILayoutBaseDePagina> = ({ children, titulo, showLogoImg, barraDeFerramentas }) => {
    const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
    const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
    const theme = useTheme();
    const { themeName } = useAppThemeContext();
    const { toggleDrawerOpen } = useDrawerContext();
    const [showModalFaleConosco, setShowModalFaleConosco] = useState(false);
    const [showModalNotificacoes, setShowModalNotificacoes] = useState(false);
    const [notificacaoes, setNotificacaoes] = useState(0);
    const [dadosNotificacaoes, setDadosNotificacaoes] = useState<IListaDadosNotificacoes[]>([]);
    const [showModalChat, setShowModalChat] = useState(false);

    const toggleModalFaleConosco = () => {
        setShowModalFaleConosco(modalVisivel => !modalVisivel);
    }

    const toggleModalChat = () => {
        setShowModalChat(modalVisivel => !modalVisivel);
    }

    const handleClickChat = () => {
        setShowModalChat(true);
    };

    const handleClick = () => {
        setShowModalFaleConosco(true);
    };

    const toggleModalNotificacoes = () => {
        setShowModalNotificacoes(modalVisivel => !modalVisivel);
    }

    useEffect(() => {

        const fetchData = async () => {
            await NotificacoesService.getAllDetalhesNotificacoes()
                .then((result) => {
                    const dados = result.dado;
                    setDadosNotificacaoes(dados);
                    setNotificacaoes(dados.filter(f => !f.visualizado).length);
                })
                .catch((errors) => {
                    console.log(errors)
                    return;
                });
        }
        fetchData();
    }, []);

    const handleClickNoticacoes = async () => {

        setShowModalNotificacoes(true);

        await NotificacoesService.updateVisualizarNotificacoes()
            .then((result) => {
                setNotificacaoes(0);
            })
            .catch((errors) => {
                console.log(errors)
                return;
            });

    }

    const boxSX = {
        "&:hover": {
            border: "none",
            fontWeight: "bold",
            color: themeName === "dark" ? "#fbc02d" : "auto"
        },
        "&": {
            border: "none",
            fontWeight: "bold",
            color: themeName === "dark" ? "#fbc02d" : "auto"
        }
    };

    function notificationsLabel(count: number) {
        if (count === 0) {
            return 'no notifications';
        }
        if (count > 99) {
            return 'more than 99 notifications';
        }
        return `${count} notifications`;
    }

    const handleAbrirModal = () => {

    }

    return (
        <>
            {showModalFaleConosco && <DialogFaleConoscoEvent isModalVisible={showModalFaleConosco} onBackClickClose={toggleModalFaleConosco} />}
            {showModalNotificacoes && <DialogNotificacoes dados={dadosNotificacaoes} isModalVisible={showModalNotificacoes} onBackClickClose={toggleModalNotificacoes} />}
            {showModalChat && <DialogChatEvent isModalVisible={showModalChat} onBackClickClose={toggleModalChat} />}

            <Box height="100%" display="flex" flexDirection="column" gap={1}>
                <Box padding={1} display="flex" alignItems="center" gap={1} height={theme.spacing(smDown ? 6 : mdDown ? 8 : 12) + 1} >
                    <Grid container spacing={1} size={{xs:12}}>
                        <Grid size={{xs:12, sm:6}} padding={1} textAlign="initial" >
                            <Box marginLeft={3} display="flex" alignItems="center" gap={1}>
                                {smDown &&
                                    <IconButton onClick={toggleDrawerOpen}>
                                        <Icon>menu</Icon>
                                    </IconButton>
                                }
                                {showLogoImg && <img src={showLogoImg} alt="SrcImagem" width={UtilidadeService.isMobile() ? "60" : "90"} height={UtilidadeService.isMobile() ? "50" : "80"} />}
                                <Typography
                                    variant={smDown ? "h5" : mdDown ? "h4" : "h3"}
                                    overflow="hidden" //Esconde quando não tiver espaço
                                    whiteSpace="nowrap" //não quebra linha
                                    textOverflow="ellipsis" // Cria os tres pontos quendo menor
                                    style={{ fontSize: UtilidadeService.isMobile() ? 14 : "1.85rem" }}
                                >
                                    {titulo}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid container size={{xs:12, sm:6}} padding={1} display="flex" justifyContent="flex-end" textAlign="end" alignSelf="center" >
                            <Grid  size={{xs:5, sm:6, md:4}} display={"none"}>
                                <Box marginLeft={3} display="flex" justifyContent="flex-end" alignItems="end" gap={1} >
                                    <Button onClick={handleClickChat} >
                                        <span style={{ color: themeName === "dark" ? "#fbc02d" : "black", fontSize: UtilidadeService.isMobile() ? 10 : 13, }}>CHAT</span>
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid  size={{xs:5, sm:6, md:4}} >
                                <Box marginLeft={3} display="flex" justifyContent="flex-end" alignItems="end" gap={1} >
                                    <Button > <Link href="https://mudfaz.com.br/#Quem%20Somos" underline="none" sx={boxSX} target='blank'>
                                        <span style={{ color: themeName === "dark" ? "#fbc02d" : "black", fontSize: UtilidadeService.isMobile() ? 10 : 13, }}>SOBRE NÓS</span>
                                    </Link>
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid  size={{xs:5, sm:6, md:4}} >
                                <Box display="flex" justifyContent="flex-end" alignItems="end" gap={1} paddingTop={UtilidadeService.isMobile() ? "5px" : "1px"}>
                                    <Button variant="outlined" onClick={handleClick} sx={boxSX}>
                                        <span style={{ color: themeName === "dark" ? "#fbc02d" : "black", fontSize: UtilidadeService.isMobile() ? 10 : 13 }}>FALE CONOSCO</span>
                                    </Button>
                                    {/* <button onClick={handleClick}>Fale Conosco</button> */}
                                </Box>
                            </Grid>
                            <Grid  size={{xs:2, sm:6, md:1}} >
                                <Box marginLeft={3} display="flex" justifyContent="flex-end"  >
                                    <IconButton aria-label={notificationsLabel(notificacaoes)} onClick={handleClickNoticacoes}>
                                        <Badge color="error" badgeContent={notificacaoes} >
                                            <Icon fontSize="medium" style={{ color: themeName === "dark" ? "#fbc02d" : "auto" }}>notifications_active</Icon>
                                        </Badge>
                                    </IconButton>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Box marginLeft={2} >
                    {barraDeFerramentas && (
                        <Box>
                            {barraDeFerramentas}
                        </Box>)
                    }
                    <Box flex={1} overflow="auto">
                        {children}
                    </Box>
                </Box>
            </Box >
        </>
    );
}
